module.exports = __webpack_public_path__ + "img/openai.b31c9297.svg";